var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFlagLv({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 140 93",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_26626_59539)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M139.13 59.3501H0.5V92.4201H139.13V59.3501Z",
    fill: "#871629"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M139.13 0H0.5V33.07H139.13V0Z",
    fill: "#871629"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M139.13 33.0699H0.5V59.3499H139.13V33.0699Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_26626_59539"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 138.63,
    height: 92.42,
    fill: "white",
    transform: "translate(0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFlagLv);
export default __webpack_public_path__ + "static/media/Flag_LV.97bb6a99ff49cc11148c8a584f71a757.svg";
export { ForwardRef as ReactComponent };